import React, { useEffect, useRef, useState } from 'react';
import { Button, Input, Modal, ModalContent, Tooltip } from '@nextui-org/react';
import { User } from '@nextui-org/react';
import { TeacherChatService } from '../../../services';
import { useSelector } from 'react-redux';
import { fromPhotos, SocketEvents } from '../../../utils';
import { useSocket } from '../../../context/socket';
import { IconPlus } from '@tabler/icons-react';
import NewChat from './new-chat';


export const Sidebar = ({ selectedChat }) => {
  const currentUser = useSelector((state) => state.user);
  const [chats, setChats] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const debounceRef = useRef(null);
  const socket = useSocket();

  useEffect(() => {
    getChats()
  }, [])

  useEffect(() => {
    if (!socket) return;
    const handleIncomingMessage = (data) => {
      console.log(data);
      setChats((prevState) => {
        const existingChats = [...prevState];
        const chatIndex = existingChats.findIndex(c => c.id === data.chat?.id);

        if (chatIndex !== -1) {
          existingChats.splice(chatIndex, 1);
        }
        existingChats.unshift(data.chat);
        return existingChats
      });
    };

    socket.on(SocketEvents.CHAT.MESSAGE, handleIncomingMessage);

    return () => {
      socket.off(SocketEvents.CHAT.MESSAGE, handleIncomingMessage);
    };
  }, [socket]);

  const getChats = async (search = '') => {
    const response = await TeacherChatService.chat.getChats({ user_id: currentUser.id, search });
    setChats(response?.data);
  }

  const onSearch = (e) => {
    if (debounceRef.current) clearTimeout(debounceRef.current);

    debounceRef.current = setTimeout(async () => {
      await getChats(e.target.value);
    }, 700);
  }

  const onSelectedChat = (chat) => {
    selectedChat({
      chat_id: chat?.id,
      user: chat?.user,
    });

    setChats(chats.map(x => x.id === chat.id ? { ...x, unread_professor: 0 } : x));
  }

  const closeModal = (chat) => {
    setOpenModal(false);
    if (!chat) return
    onSelectedChat(chat)
  }


  return (
    <div className="w-80 bg-gray-100 pb-4 pr-4 max-h-[calc(100vh-6rem)] overflow-y-auto">

      <Modal
        size="lg"
        isOpen={openModal}
        onClose={() => closeModal()}
        backdrop="blur"
        scrollBehavior="outside"
      >
        <ModalContent>
          {(onClose) => {
            return <NewChat
              onClose={onClose}
              onSuccess={(data) => closeModal(data)}
            />
          }}
        </ModalContent>
      </Modal>

      <div className='flex items-center gap-3 my-4'>
        <Input
          clearable
          underlined
          labelPlacement='outside'
          variant='bordered'
          radius='sm'
          placeholder="Busca un chat"
          onChange={onSearch}
        />
        <Tooltip content="Nuevo chat" delay={0} placement="top">
          <IconPlus className='cursor-pointer' size={20} onClick={() => setOpenModal(true)} />
        </Tooltip>
      </div>
      <div className="space-y-4">
        {
          chats.length > 0 ? (
            chats?.map((chat) => {
              const user = chat?.parent_id === currentUser.id ? chat?.professor : chat?.parent;
              return (
                <div
                  key={chat?.id}
                  className="flex items-center space-x-4 cursor-pointer hover:bg-gray-200 p-2 relative border-b-1 border-gray/20"
                  onClick={() => onSelectedChat({ ...chat, user: chat?.parent })}
                >

                  <User
                    key={user?.photo}
                    avatarProps={{ showFallback: true, radius: 'full', src: user?.photo ? fromPhotos(user?.photo) : null }}
                    classNames={{ description: 'text-foreground-500' }}
                  />
                  <div>
                    <p className="font-semibold text-sm capitalize max-w-[180px] line-clamp-2">{user?.fullname}</p>
                    <div className='flex items-center gap-2'>
                      {
                        chat?.last_message?.user_id === currentUser.id && (
                          <span className='text-xs font-bold'>Yo:</span>
                        )
                      }
                      <p className="text-sm text-gray-500 overflow-hidden text-ellipsis line-clamp-1">{chat?.last_message?.message}</p>

                    </div>
                  </div>
                  {
                    chat?.unread_professor > 0 && (
                      <div className='absolute right-0 top-1/2 transform -translate-y-1/2 bottom-0 flex items-center justify-center gap-2 w-5 h-5 bg-primary rounded-full text-white'>
                        <span>{chat?.unread_professor}</span>
                      </div>
                    )
                  }
                </div>

              )
            })
          )
            : (
              <div className="flex items-center space-x-4 f-full hover:bg-gray-200 p-2 rounded-lg">
                <div>
                  <p className="text-sm text-gray-500">No posee chats</p>
                </div>
              </div>

            )
        }


      </div>
    </div>
  );
};
